import { Form, Input, message, Spin } from "antd";
import React, { Component } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { PageTitle, FormBtn, RequriedText } from "lib/widget";

const FormItem = Form.Item;

export default class NationalityForm extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const { errorMessage, alertMessage } = nextProps;

    if (alertMessage !== "") {
      return { alertMessage: alertMessage };
    }

    if (errorMessage !== "") {
      return { errorMessage: errorMessage };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { errorMessage, alertMessage } = this.props;
    const prevMsg = prevProps;

    if (errorMessage !== "" && prevMsg.errorMessage !== errorMessage) {
      message.error(errorMessage);
    }

    if (alertMessage !== "" && prevMsg.alertMessage !== alertMessage) {
      message.success(alertMessage);
    }
  }

  componentDidMount() {
    this.nameInput.focus(); 
  }

  isDisabled = () => {
    return this.props.nationality.nationality_code !== '' && this.props.editCode
  }

  render() {
    const { nationality, onSubmit } = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      }
    };

    return (
      <div>
        <Spin size="large" spinning={this.props.loading}>
          <PageTitle name="customer_nationalities" component={null} />
          <Formik
            initialValues={nationality}
            enableReinitialize={true}
            validationSchema={yup.object().shape({
              nationality: yup.string().required("Nationality is a required field"),
              nationality_code: yup.string().required("Code is a required field"),
            })}
            onSubmit={values => onSubmit(values)}
            render={({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit
            }) => (
              <Form onFinish={handleSubmit} autoComplete="off">
                <fieldset disabled={!this.props.canEdit}>
                <FormItem
                    {...formItemLayout}
                    label={<RequriedText label="Code" />}
                    validateStatus={errors.nationality_code && "error"}
                    help={touched.nationality_code && errors.nationality_code}
                  >
                    <Input
                      ref={(input) => { this.nameInput = input; }}
                      name="nationality_code"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.nationality_code}
                      disabled={this.isDisabled()}
                    />
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label="Nationality"
                    validateStatus={errors.nationality && "error"}
                    help={touched.nationality && errors.nationality}
                  >
                    <Input
                      
                      name="nationality"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.nationality}
                    />
                  </FormItem>
                  <FormBtn
                    url="/customer/nationalities"
                    canEdit={this.props.canEdit}
                  />
                </fieldset>
              </Form>
            )}
          />
        </Spin>
      </div>
    );
  }
}
